/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ReviewsTourLeaderResponse } from '../../models/reviews-tour-leader-response';

export interface TravelControllerGetReviewsTourLeader$Params {
  limit: number;
  skip: number;
  tour_leader_id: number;
}

export function travelControllerGetReviewsTourLeader(http: HttpClient, rootUrl: string, params: TravelControllerGetReviewsTourLeader$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ReviewsTourLeaderResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerGetReviewsTourLeader.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.path('tour_leader_id', params.tour_leader_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ReviewsTourLeaderResponse;
      }>;
    })
  );
}

travelControllerGetReviewsTourLeader.PATH = '/travel/reviews/tour-leader/{tour_leader_id}';
